				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class DeliveryZoneGroupService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('DeliveryZoneGroup');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.DeliveryZoneGroup[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllEdit(): Observable<TooBig4Car.Logic.DeliveryZoneGroup[]> {
		return this.myBaseService.loadAll(this.url + '/EditAll');
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.DeliveryZoneGroup> {
		return this.myBaseService.save(tempItem, this.url);
	}
	saveBulk(vmCol: TooBig4Car.Logic.DeliveryZoneGroup[]): Observable<string> {
		return this.myBaseService.post(vmCol, this.url + '/BulkSave', true);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.DeliveryZoneGroup> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.DeliveryZoneGroup>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<TooBig4Car.Logic.DeliveryZoneGroup[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}
				
